// Module
var code = "<svg-icon params=\"name: 'chevron-bottom', size: size\" data-bind=\"attr: {\n  'data-open': isOpen\n}, style: {\n  color: color,\n  width: width ? width + 'px' : (size ? size + 'px' : null),\n  height: height ? height + 'px' : (size ? size + 'px' : null)\n}\"></svg-icon>\n";
// Exports
module.exports = code;